var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExtractedFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "127px",
    height: "126px",
    viewBox: "0 0 127 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "extracted-features") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "extracted-features",
    transform: "translate(0.426000, 0.133000)",
    fill: "#132735",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.825,37.622 C38.825,28.797 41.043,20.49 44.927,13.212 L4.933,13.212 C2.21,13.212 0,15.419 0,18.143 L0,120.907 C0,123.631 2.21,125.841 4.933,125.841 L107.695,125.841 C110.419,125.841 112.628,123.63 112.628,120.907 L112.628,84.702 C105.98,87.795 98.591,89.571 90.774,89.571 C62.084,89.57 38.825,66.312 38.825,37.622 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.939,5.235 L125.939,2.517 C125.939,1.127 124.816,0 123.425,0 L120.335,0 C120.335,0 120.335,0.001 120.337,0.001 L71.013,0.001 C69.624,0 68.495,1.127 68.499,2.517 L82.132,16.154 L82.132,16.154 L87.271,21.293 L54.211,54.352 C53.229,55.333 53.229,56.93 54.211,57.912 L68.032,71.73 C69.011,72.711 70.606,72.711 71.589,71.73 L104.646,38.667 L104.646,38.667 L109.789,43.807 L123.429,57.444 C124.817,57.444 125.944,56.318 125.944,54.925 L125.944,5.237 C125.939,5.236 125.939,5.235 125.939,5.235 Z",
    id: "Path"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtractedFeatures);
export default __webpack_public_path__ + "static/media/extracted-features.4f9abbd04117bca70dee6738ce918da1.svg";
export { ForwardRef as ReactComponent };